import athenaConfig from '../config';
import AmplitudeUtils from './amplitude-utils';
import { ERROR_KEYS, ERROR_MESSAGES } from '../constants';
import { makeRequestWithRetry } from './api-retry-utils';

/**
 * Transforms an error into the shape Okta's widget reads to populate the error banner.
 * https://github.com/okta/okta-signin-widget/blob/7.8/src/v2/controllers/FormController.ts#L373
 */
export function getTransformedError(error?: any) {
  const transformedError = error || {};
  transformedError.errorSummary = ERROR_MESSAGES[ERROR_KEYS.FIDO2_SKIP_ENROLLMENT_ERROR];
  return transformedError;
}

export async function skipFido2Enrollment(stateHandle: string, username: string): Promise<void> {
  try {
    await makeRequestWithRetry({
      url: `${athenaConfig.fido2EnforcementLambdaBaseUrl}/skip-enrollment`,
      args: { stateHandle, username },
      retryEventName: 'Fido2SkipEnrollmentRetry',
      metadata: { username },
    });
  }
  catch (error: any) {
    AmplitudeUtils.logCustomEvent('Fido2SkipEnrollment::Error', { error });
    throw error;
  }
}
